export type TaskDescriptionVisibility = {
  hasDescriptionValue: boolean;
  showDescription: boolean;
  showClearDescription: boolean;
};

export function resolveTaskDescriptionVisibility(
  description: string | null | undefined,
  editDescription: boolean,
): TaskDescriptionVisibility {
  const hasDescriptionValue = Boolean(description?.trim());

  return {
    hasDescriptionValue,
    showDescription: hasDescriptionValue || editDescription,
    showClearDescription: editDescription,
  };
}
